import { ButtonType } from '@tableau/widgets';
import React = require('react');
import { Messages } from '~src/codegen/Localize';
import { ButtonWithSpinner } from '~src/common/react/components/ButtonWithSpinner';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SettingsCoordinatorContext } from '~src/settings/components/settings-coordinator/SettingsCoordinatorContexts';
import { useSettingsCoordinatorStateInternal } from '~src/settings/components/settings-coordinator/SettingsCoordinatorHook';
import ReactSiteSettingsForServerAdmin from '~src/settings/general-settings/components/site-settings/ReactSiteSettingsForServerAdminSubFormik';
import { ReactSiteSettingsForSiteAdmin } from '~src/settings/general-settings/components/site-settings/ReactSiteSettingsForSiteAdminSubFormik';
import { ISiteAuthenticationSettings } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { ISiteSettingsForServerAdmin } from '~src/settings/types/ISite';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';
import { IEditableServerSettings } from '~src/ts/ServerApi/types/IEditableServerSettings';

import { ToasterService, ToastType } from '../../services/ToasterService';

export interface EditSiteSettingDialogProps {
readonly dismiss: () => void;
readonly close: (result: any) => void;
serverSettings: IEditableServerSettings;
siteSettings: ISiteSettingsForSiteAdmin;
siteSettingsForServerAdmin: ISiteSettingsForServerAdmin;
siteAuthenticationSettings: ISiteAuthenticationSettings;
}


export function EditSiteSettingDialog(props: EditSiteSettingDialogProps) {

   const failureHandler = (error: any) => {
    if (Array.isArray(error)) {
      error.forEach(errorMessage => ToasterService.instance.pop({
          type: ToastType.Error,
          text: errorMessage,
        },
      ));
    } else {
      ToasterService.instance.pop({type: ToastType.Error, text: Messages.settingsUpdateFailure()});
    }
    props.close({});
  };

  const submitHandler = () => {
    ToasterService.instance.pop({type: ToastType.Success, text: Messages.settingsUpdateSuccess()});
    props.close({});
  };

  const {dispatch, triggerResetDefault, ...saveCancelProps} = useSettingsCoordinatorStateInternal(
    submitHandler as any,
    failureHandler as any
  );

  const sessionManagementService = getSessionManagementServiceInstance();

  const shouldRenderServerAdminForm = sessionManagementService.isSessionServerAdmin();
  const shouldRenderSiteAdminForm = sessionManagementService.isSessionServerAdmin()
    || (sessionManagementService.isSessionSiteAdmin() && sessionManagementService.isOnlineEnvironment());

    return (
    <>
        <div>
          <div className="tb-dialog-title">
            <span>{Messages.editSiteSettings()}</span>
          </div>
          <div  className="tb-site-dialog">
            <SettingsCoordinatorContext.Provider value={dispatch}>
              {shouldRenderServerAdminForm &&
                <ReactSiteSettingsForServerAdmin settings={props as any} />}

              {shouldRenderSiteAdminForm &&
                <ReactSiteSettingsForSiteAdmin settings={props as any} />}
            </SettingsCoordinatorContext.Provider>
          </div>
          <div className="tb-dialog-actions">
            <ButtonWithSpinner
              buttonType={ButtonType.Outline}
              showSpinner={false}
              clicked={props.dismiss}
              testId={'confirm-action-dialog-cancel'}
              title={Messages.cancel()}
              disabled={saveCancelProps.isAnySubmitting}
            />
            <span className="tb-margin-left-wide">
              <ButtonWithSpinner
                testId={'confirm-action-dialog-confirm'}
                buttonType={ButtonType.Primary}
                disabled={!saveCancelProps.isAnyDirty || saveCancelProps.isAnySubmitting || saveCancelProps.isAnyInvalid}
                onClick={saveCancelProps.triggerSave}
                title={Messages.save()}
                showSpinner={saveCancelProps.isAnySubmitting}
              />
            </span>
          </div>
        </div>
  </>

  );
}